import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  TextField,
  InputAdornment,
} from '@mui/material';
import {
  Add as AddIcon,
  Search as SearchIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material';
import { useGetRmasQuery } from '../../../store/api/rmaApi';

const STATUS_COLORS = {
  pending_dispatch: 'warning',
  dispatched: 'info',
  under_repair: 'secondary',
  replaced: 'success',
  credit_issued: 'primary',
  closed: 'default',
};

const STATUS_LABELS = {
  pending_dispatch: 'Pending Dispatch',
  dispatched: 'Dispatched',
  under_repair: 'Under Repair',
  replaced: 'Replaced',
  credit_issued: 'Credit Issued',
  closed: 'Closed',
};

export default function RmaList() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const { data, isLoading } = useGetRmasQuery({ search: searchTerm });

  const rmas = data?.rmas || [];

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4" component="h1">
          RMA (Returns)
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/rma/new')}
        >
          New RMA
        </Button>
      </Box>

      <Paper sx={{ width: '100%', mb: 2, p: 2 }}>
        <Box sx={{ display: 'flex', mb: 2, gap: 2 }}>
          <TextField
            size="small"
            placeholder="Search RMA No..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={{ width: 300 }}
          />
        </Box>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>RMA No.</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Product</TableCell>
                <TableCell>Defective IMEI</TableCell>
                <TableCell>Supplier</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">Loading...</TableCell>
                </TableRow>
              ) : rmas.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">No RMAs found.</TableCell>
                </TableRow>
              ) : (
                rmas.map((ticket) => (
                  <TableRow key={ticket.id}>
                    <TableCell sx={{ fontWeight: 600 }}>{ticket.rmaNumber}</TableCell>
                    <TableCell>{new Date(ticket.createdAt).toLocaleDateString()}</TableCell>
                    <TableCell>{ticket.productImei?.product?.name}</TableCell>
                    <TableCell>{ticket.productImei?.imei}</TableCell>
                    <TableCell>{ticket.supplier?.name || '-'}</TableCell>
                    <TableCell>
                      <Chip
                        label={STATUS_LABELS[ticket.status] || ticket.status}
                        color={STATUS_COLORS[ticket.status] || 'default'}
                        size="small"
                      />
                    </TableCell>
                    <TableCell align="right">
                      <Button
                        size="small"
                        startIcon={<VisibilityIcon />}
                        onClick={() => navigate(`/rma/${ticket.id}`)}
                      >
                        View
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}
